module.exports = __webpack_public_path__ + "img/service-stick.af8fafaa.png";